/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "src/domains/i18n/language/I18n-provider.tsx"

import { MuiThemeProvider } from "@material-ui/core"
import { StylesProvider } from "@material-ui/core/styles"

import { isClient } from "src/domains/app/utils.ts"

import App from "./src/domains/app/app"
import GlobalStyles from "./src/domains/app/global-styles"
import theme from "./src/theme-legacy"

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to App as Page element will get
  // including location, data, etc - you don't need to pass it
  return (
    <MuiThemeProvider theme={theme}>
      <GlobalStyles {...props}>
        <StylesProvider injectFirst>
          {isClient && <App {...props}>{element}</App>}
        </StylesProvider>
      </GlobalStyles>
    </MuiThemeProvider>
  )
}
